module.exports = __webpack_public_path__ + "static/img/3-4.ab0049d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/3-4.png
// module id = 953
// module chunks = 30